if (!customElements.get('svc-view-controls')) {
  customElements.define(
    'svc-view-controls',
    class SvcViewControls extends HTMLElement {
      connectedCallback() {
        this.page = this.closest('.shells-v2-page');
        this.toggle = this.querySelector('[data-svc-second-image]');
        this.colButtons = Array.from(this.querySelectorAll('[data-svc-cols]'));
        const storedCols = window.localStorage.getItem('heavys-svc-cols');
        const storedSecond = window.localStorage.getItem('heavys-svc-second-image');
        this.setColumns(storedCols === '3' || storedCols === '4' || storedCols === '5' ? storedCols : '5');
        this.setSecondImage(storedSecond === '1');

        if (this.toggle) {
          this.toggle.addEventListener('change', () => {
            this.setSecondImage(this.toggle.checked);
          });
        }

        this.colButtons.forEach((button) => {
          button.addEventListener('click', () => this.setColumns(button.dataset.svcCols));
        });
      }

      setSecondImage(on) {
        if (this.toggle) this.toggle.checked = on;
        if (this.page) this.page.classList.toggle('is-second-image', on);
        window.localStorage.setItem('heavys-svc-second-image', on ? '1' : '0');
      }

      setColumns(cols) {
        const value = cols === '3' || cols === '4' ? cols : '5';
        if (this.page) this.page.setAttribute('data-svc-cols', value);
        this.colButtons.forEach((button) => {
          button.setAttribute('aria-pressed', button.dataset.svcCols === value ? 'true' : 'false');
        });
        window.localStorage.setItem('heavys-svc-cols', value);
      }
    },
  );
}
